import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MeterDto } from '@app/api/dmc';
import { MeterService, RemoveMeterDto } from '@app/api/nts';
import { InputDirective } from '@shared/components/input/input/input.directive';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { FormApiService } from '@app/core/services/form-api.service';
import { InputDateDirective } from '@shared/components/input/date/input-date.directive';

@Component({
  selector: 'app-meter-remove',
  imports: [
    FormsModule,
    InputDirective,
    InputGroupComponent,
    LabelDirective,
    ReactiveFormsModule,
    TranslatePipe,
    InputDateDirective
  ],
  templateUrl: './meter-remove.component.html',
  styleUrl: './meter-remove.component.css'
})
export class MeterRemoveComponent implements OnInit {
  public form: FormGroup = new FormGroup({
    decommissioningDate: new FormControl<string | undefined>(undefined, [Validators.required]),
    meterNumber: new FormControl<string | undefined>(undefined),
    alternateMeterNumber: new FormControl<string | undefined>(undefined),
    serialNumber: new FormControl<string | undefined>(undefined),
    meterId: new FormControl<string | undefined>(undefined),
    meterFrameId: new FormControl<string | undefined>(undefined),
  });

  public meterDto?: MeterDto;

  constructor(
    private readonly formApiService: FormApiService,
    private readonly meterService: MeterService,
  ) {
  }

  public ngOnInit(): void {
    this.form.get('meterNumber')?.setValue(this.meterDto?.meterNumber);
    this.form.get('alternateMeterNumber')?.setValue(this.meterDto?.alternateMeterNumber);
    this.form.get('serialNumber')?.setValue(this.meterDto?.serialNumber);
    this.form.get('meterId')?.setValue(this.meterDto?.id);
    this.form.get('meterFrameId')?.setValue(this.meterDto?.meterFrameId);
  }

  public submit(): void {
    if (this.form.valid) {
      this.formApiService.submit<RemoveMeterDto>(
        this.form,
        (data) => this.meterService.meterRemovePost(data),
        {
          preprocess: (data: any) => ({
            ...data,
            occurrence: data.decommissioningDate,
          }),
          successMessage: 'meter.meterClosed',
          closeModal: true,
        }
      )
    } else {
      this.form.markAllAsTouched();
    }
  }

}
